import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import editresultapi from '../../api/editresult';
import loginapi from '../../api/login';

import { AiOutlineUp, AiOutlineDown } from "react-icons/ai";
import DeleteConfirmation from '../ConfirmDelete';

const CourseForm = ({ course, index, handleChange,handleCourseSave ,handleCourseDelete}) => {

  const handleDelete = (e, index) => {
    setShowModal(true);
  };

   
    const [showModal, setShowModal] = useState(false);
    
    return (
      <div id="containerdiv" className="w-full p-1  border-b-[1px] border-b-red-900   mb-2 py-3">
        <div className="text-center w-full max-w-full grid grid-cols-[30px_auto] mb-2">
          <p className="text-xs text-gray-500 text-left bg-gray-200">{index + 1}.</p>
          <p className="text-xs font-semibold text-left px-2 bg-gray-100">{course.title}</p>
        </div>
   
  
          <div
            id="coursesdiv"
            className="text-center w-full max-w-full  grid grid-cols-[1fr_2.5fr_2.5fr_2.5fr_2.5fr_.8fr_2.5fr_1.5fr_1.5fr_1.5fr_1.5fr_1.5fr_1.5fr_1.5fr_1fr] lg:gap-1 p-1 text-sm"
          >
            <div className="w-full flex flex-col px-1">
              <label className="text-xs text-transparent ">.sss</label>
                <button
                    className={`rounded p-1 text-xs shadow-md transition duration-200 
                      ${true ? "bg-gray-400 text-white hover:bg-gray-500 hover:shadow-lg" : "bg-gray-400 text-gray-200 "}
                    `}
                    onClick={(e) => handleDelete(e, index)}
                  >
                    DELETE
                 </button>
            </div>

            <div className="flex flex-col w-full px-1">
              <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Code</label>
              <p className="w-full text-xs p-1 font-semibold  mt-1">{course.course_code}</p>
            </div>  

              <div className="w-full flex px-1 lg:gap-1">
              <div className="w-full flex flex-col">      
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">InT</label>

                <input
                  type="text"
                  autoComplete="off"
                  name="midterm_total"
                  value={course.midterm_total}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                />


               
              </div>
              <div className="w-full flex flex-col ">      
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">InP</label>
                
                <input
                  type="text"
                  autoComplete="off"
                  name="midterm_pass"
                  value={course.midterm_pass}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                />

                </div>
              </div>

              <div className="w-full flex px-1 lg:gap-1">
                <div className="w-full flex flex-col">      
                  <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">PrT</label>
                  <input
                  type="text"
                  autoComplete="off"
                  name="practical_total"
                  value={course.practical_total}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                />
                </div>
                <div className="w-full flex flex-col">      
                  <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">PrP</label>
                 
                  <input
                  type="text"
                  autoComplete="off"
                  name="practical_pass"
                  value={course.practical_pass}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                />
                </div>
              </div>

              <div className="w-full flex px-1 lg:gap-1">
              <div className="w-full flex flex-col">      
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">ThT</label>
                <input
                  type="text"
                  autoComplete="off"
                  name="endterm_total"
                  value={course.endterm_total}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                />
               
              </div>
              <div className="w-full flex flex-col">      
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">ThP</label>
               
                <input
                  type="text"
                  autoComplete="off"
                  name="endterm_pass"
                  value={course.endterm_pass}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                />
              </div>
              </div>


            <div className="w-full flex flex-col px-1">
              <label className="text-xs text-gray-500  border-b-[1px] border-gray-600">Cr</label>
              <input
                  type="text"
                  autoComplete="off"
                  name="credit"
                  value={course.credit}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                />
              
            </div>


              <div className="flex flex-col w-full px-1">
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Type</label>
                <select
                  name="course_type"
                  value={course.course_type}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                >
                  <option value="core">Core</option>
                  <option value="elective">Elective</option>
                </select>
              </div>

              <div className="w-full flex flex-col px-1">
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">In</label>
                <input
                  type="text"
                  autoComplete="off"
                  name="midterm"
                  value={course.midterm}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                />
              </div>

              <div className="w-full flex flex-col px-1">
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Pr</label>
                <input
                  type="text"
                  autoComplete="off"
                  name="practical"
                  value={course.practical}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm mt-1"
                />
              </div>

              <div className="w-full flex flex-col px-1">
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Th</label>
                <input
                  type="text"
                  autoComplete="off"
                  name="endterm"
                  value={course.endterm}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm mt-1"
                />
              </div>

              <div className="w-full flex flex-col px-1">
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">%</label>
                <input
                  type="text"
                  autoComplete="off"
                  name="percent"
                  value={course.percent}
                  onChange={(e) => handleChange(e, index)}
                  className={`w-full border-b-2 border-blue-500 p-1 text-sm mt-1 ${parseFloat(course.percent) !== parseFloat(course.actualPercent) ? 'bg-red-200' : 'white'}`}
                />
              </div>

              <div className="w-full flex flex-col px-1">
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">GRD</label>
                <select
                  name="grade"
                  value={course.grade}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full border-b-2 border-blue-500 p-1 text-sm  mt-1"
                >
                  <option value='NE'></option>
                  <option value="O">O</option>
                  <option value="A+">A+</option>
                  <option value="A">A</option>
                  <option value="B+">B+</option>
                  <option value="B">B</option>
                  <option value="C+">C+</option>
                  <option value="C">C</option>
                  <option value="P">P</option>
                  <option value="F">F</option>
                </select>
              </div>


              <div className="w-full flex flex-col px-1">
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">GP</label>
                <input
                  type="text"
                  autoComplete="off"
                  name="gradepoint"
                  value={course.gradepoint}
                  onChange={(e) => handleChange(e, index)}
                  className={`w-full border-b-2 border-blue-500 p-1 text-sm mt-1 ${parseFloat(course.gradepoint) !== parseFloat(course['actualGradePoint']) ? 'bg-red-200' : 'white'}`}
                />
              </div>

              <div className="w-full flex flex-col px-1">
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">HnrPt</label>
                <input
                  type="text"
                  autoComplete="off"
                  name="honur_point"
                  autocomplete="off"
                  value={course.honur_point}
                  onChange ={(e) => handleChange(e, index)}
                  className={`w-full border-b-2 border-blue-500 p-1 text-sm mt-1 ${parseFloat(course.honur_point) !== parseFloat(course.actualHonourPoint) ? 'bg-red-200' : 'white'}`}
                />
              </div>

              <div className="w-full flex flex-col">
  <label className="text-sm text-transparent">.sss</label>
      <button
          className={`rounded p-1 text-xs shadow-md transition duration-200 mt-1
            ${course.isModified ? "bg-blue-500 text-white hover:bg-gray-500 hover:shadow-lg" : "bg-gray-400 text-gray-200 "}
          `}
          onClick={(e) => handleCourseSave(e, index)}
          disabled={!course.isModified}
        >
          SAVE
      </button>

</div>
          </div>

          <DeleteConfirmation
              isOpen={showModal}
              onCancel={() => setShowModal(false)}
              onDelete={() => {
                setShowModal(false);
                //call the actual delete function
                handleCourseDelete(index);
              }}
            />          
      </div>


    );
  };
  
  const ResultForm = ({ result, handleChange ,handleResultSave,totalHonourPoint,totalCredit, totalMajorCredit,totalMajorHonourPoint }) => {
    return (
      <div id="containerdiv" className="w-full p-1     mb-2 ">
      

          <div
            id="coursesdiv"
            className="text-center w-full max-w-full  grid grid-cols-[2.5fr_2.5fr_1fr_1fr] lg:gap-1 md:p-1 text-sm"
          >
                  <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">MjrCr</label>
                         <input
                          type="text" autoComplete="off"
                          name="majorcredit"
                          value={result.majorcredit}
                          onChange={handleChange}
                          className={`w-full border rounded p-2 mt-1  ${parseFloat(result.majorcredit) !== totalMajorCredit ? 'bg-red-200' : ''}`}
                        />
                    </div>
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">MjrGp</label>
                         <input
                          type="text" autoComplete="off"
                          name="majorgp"
                          value={result.majorgp}
                          onChange={handleChange}
                          className={`w-full border rounded p-2 mt-1 ${parseFloat(result.majorgp) !== totalMajorHonourPoint ? 'bg-red-200' : ''}`}
                        />
                    </div>
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">MjrSGP</label>
                         <input
                          type="text" autoComplete="off"
                          name="sgpamajor"
                          value={result.sgpamajor}
                          onChange={handleChange}
                          className={`w-full border rounded p-2 mt-1 ${parseFloat(result.sgpamajor) !== parseFloat(result.actualMSGPA) ? 'bg-red-200' : ''}`}
                        />
                    </div>
                  </div> 

                  <div className="w-full flex px-2">
                    
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">AllCr</label>
                        <input
                            type="text" autoComplete="off"
                            name="allcredit" 
                            value={result.allcredit}
                            onChange={handleChange}
                            className={`w-full border rounded p-2 mt-1 ${parseFloat(result.allcredit) !== totalCredit ? 'bg-red-200' : ''}`}
                          />
                    </div>
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">AllGp</label>
                        <input
                            type="text" autoComplete="off"
                            name="allgp"
                            value={result.allgp}
                            onChange={handleChange}
                            className={`w-full border rounded p-2 mt-1 ${parseFloat(result.allgp) !== totalHonourPoint ? 'bg-red-200' : ''}`}
                          />
                    </div>
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">AllSGP</label>
                        <input
                            type="text" autoComplete="off"
                            name="sgpaall"
                            value={result.sgpaall}
                            onChange={handleChange}
                            className={`w-full border rounded p-2 mt-1 ${parseFloat(result.sgpaall) !== parseFloat(result.actualASGPA) ? 'bg-red-200' : ''}`}
                            
                          />
                    </div>
                  </div> 

                 
                  <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">CrERND</label>
                         <input
                          type="text" autoComplete="off"
                          name="credit_earned"
                          value={result.credit_earned}
                          onChange={handleChange}
                          className="w-full border rounded p-2 mt-1"
                        />
                    </div>
                  </div> 

                  <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">  
                <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Result</label>
                <select
                  name="result"
                  value={result.result}
                  onChange={handleChange}
                  className="w-full border-b-2 border-blue-500 p-2 text-sm  mt-1"
                >
                  <option value="NE">SELECT</option>
                  <option value="PASS">PASS</option>
                  <option value="FAIL">FAIL</option>
                </select>
                </div>
                </div> 
          </div>
          <div
            id="coursesdiv"
            className="text-center w-full max-w-full  grid grid-cols-[1fr_1fr_1fr_2fr_1fr] lg:gap-1 md:p-1 text-sm"
          >
              <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">RsltDt.</label>
                      <input
                          type="date"
                          id="dateInput"
                          name="result_date"
                          value={result.result_date}
                          onChange={handleChange}
                          className="w-full border rounded p-2 mt-1"
                           />
                    </div>
                  </div> 
                  
                  <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">IssueDt.</label>
                      <input
                          type="date"
                          id="dateInput"
                          name="issue_date"
                          value={result.issue_date}
                          onChange={handleChange}
                          className="w-full border rounded p-2 mt-1"
                           />
                    </div>
                  </div> 

                  <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">GrdCrdSLNO</label>
                         <input
                          type="text" autoComplete="off"
                          name="gradecard_slno"
                          value={result.gradecard_slno}
                          onChange={handleChange}
                          className="w-full border rounded p-2 mt-1"
                        />
                    </div>
                  </div> 

                  <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Exam Mnth,Yr,Type</label>
                         <div className="w-full flex gap-1">
                           <select
                              name="exam_month"
                              value={result.exam_month}
                              onChange={handleChange}
                              className="w-full border-b-2 border-blue-500 p-2 text-sm mt-1"
                            >
                              <option value="">SELECT</option>
                              <option value="JANUARY">JANUARY</option>
                              <option value="FEBRUARY">FEBRUARY</option>
                              <option value="MARCH">MARCH</option>
                              <option value="APRIL">APRIL</option>
                              <option value="MAY">MAY</option>
                              <option value="JUNE">JUNE</option>
                              <option value="JULY">JULY</option>
                              <option value="AUGUST">AUGUST</option>
                              <option value="SEPTEMBER">SEPTEMBER</option>
                              <option value="OCTOBER">OCTOBER</option>
                              <option value="NOVEMBER">NOVEMBER</option>
                              <option value="DECEMBER">DECEMBER</option>
                            </select>

                            <select
                                name="exam_year"
                                value={result.exam_year}
                                onChange={handleChange}
                                className="w-full border-b-2 border-blue-500 p-2 text-sm mt-1"
                              >
                                <option value="">SELECT</option>
                                {[...Array(2032 - 2019 + 1)].map((_, index) => {
                                  const year = 2019 + index;
                                  return (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  );
                                })}
                              </select>

                              <select
                              name="exam_type"
                              value={result.exam_type}
                              onChange={handleChange}
                              className="w-full border-b-2 border-blue-500 p-2 text-sm mt-1"
                            >
                              <option value="">SELECT</option>
                              <option value="REGULAR">REGULAR</option>
                              <option value="AREAR">AREAR</option>
                              <option value="BETTERMENT">BETTERMENT</option>
                            </select>

                         </div>

                         
                    </div>
                  </div> 

                  <div className="w-full flex flex-col">
                    <label className="text-sm text-transparent">.sss</label>
                    <button
                    className={`rounded p-2 text-xs shadow-md transition duration-200 mt-1
                      ${result.isModified ? "bg-blue-500 text-white hover:bg-gray-500 hover:shadow-lg" : "bg-gray-400 text-gray-200 "}
                    `}
                    onClick={(e) => handleResultSave(e)}
                    disabled={!result.isModified}
                  >
                    SAVE
                  </button>
                  </div>
          </div>
    </div>
    );
  };
  
  
  
export default function SemesterResult({accessToken,setAccessToken,setRefreshFailed,rollno,session,semester}) {
  const navigate = useNavigate();
  const [courses, setCourses] = useState(
   []    
  );

  const [result, setResult] = useState({
  });
  const [initialCourses, setInitialCourses] = useState([]); // Store initial state
  const [modifiedCourses, setModifiedCourses] = useState([]); // Track individual course modifications
  const [initialResult, setInitialResult] = useState({}); // Store initial state
  
  const [totalHonourPoint, setTotalHonourPoints] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const [totalMajorHonourPoint, setTotalMajorHonourPoint] = useState(0);
  const [totalMajorCredit, setTotalMajorCredit] = useState(0);

  const [showDetails,setShowDetails]=useState(false);
  const [dataLoaded,setDataLoaded]=useState(false);
  
  const computeActualScores = (courses) => {
    function getNumericGrade(letterGrade) {
      const gradeMapping = {
        'O': 10, 'A+': 9, 'A': 8, 'B+': 7, 'B': 6,
        'C+': 5, 'C': 4, 'P': 4
      };
      return gradeMapping[letterGrade] || 0;
    }
  
    return courses.map(course => {
      let mt = Number(course['midterm']) || 0;
      let pr = Number(course['practical']) || 0;
      let et = Number(course['endterm']) || 0;
      let mtm = Number(course['midterm_total']) || 0;
      let prm = Number(course['practical_total']) || 0;
      let etm = Number(course['endterm_total']) || 0;
      
      let gt = mt + et + pr;
      let gtm = mtm + etm + prm;
  
      let actualPercent = gtm > 0 ? Math.round((gt / gtm) * 100) : 0;
      let actualGradePoint = getNumericGrade(course['grade']);
      let actualHonourPoint = course['gradepoint'] * course['credit'];
  
      return {
        ...course,
        actualPercent,
        actualGradePoint,
        actualHonourPoint
      };
    });
  };
  
  const handleCourseChange = (e, index) => {
    const { name, value } = e.target;
    //if(name==='grade'){alert(initialCourses[index].grade);}
    const updatedCourses = courses.map((course, i) =>
      i === index ? { ...course, [name]: value } : course
    );
  
    const computedCourses = computeActualScores(updatedCourses);
    // Update isModified flag for the specific course
    computedCourses[index].isModified = checkIfCourseModified(computedCourses[index], index);
    setCourses(computedCourses);
  };
  
  const handleCourseSave = async (e, index) => {
    e.preventDefault();
    const updatedCourse = courses[index];
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await editresultapi.post('/updateCourse',updatedCourse,{headers:{'Authorization':`Bearer ${accessToken}`}});  
      if(response.data.course)
      {
        setInitialCourses((prevInitialCourses) => {
          const newInitialCourses = [...prevInitialCourses];
          newInitialCourses[index] = { ...updatedCourse, isModified: false };
          return newInitialCourses;
        });
  
        // Also update the courses array to reset isModified
        setCourses((prevCourses) => {
          const newCourses = [...prevCourses];
          newCourses[index].isModified = false;
          return newCourses;
        });
      }

         }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await editresultapi.post('/updateCourse',updatedCourse,{headers:{'Authorization':`Bearer ${nat}`}});   
                      // Compute courses and add an isModified flag to each course
                      if(response.data.course)
                        {
                          setInitialCourses((prevInitialCourses) => {
                            const newInitialCourses = [...prevInitialCourses];
                            newInitialCourses[index] = { ...updatedCourse, isModified: false };
                            return newInitialCourses;
                          });
                    
                          // Also update the courses array to reset isModified
                          setCourses((prevCourses) => {
                            const newCourses = [...prevCourses];
                            newCourses[index].isModified = false;
                            return newCourses;
                          });
                        }
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };
  const handleCourseDelete = async (index) => {
    const dcourse = courses[index];
    //alert(JSON.stringify(dcourse));
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await editresultapi.post('/deleteFormFillUpCourse',dcourse,{headers:{'Authorization':`Bearer ${accessToken}`}});  
      
      await fetchSemesterResult();
         }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await editresultapi.post('/deleteFormFillUpCourse',dcourse,{headers:{'Authorization':`Bearer ${nat}`}});   
                      await fetchSemesterResult();
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
   
  };
  

  const handleResultChange = (e) => {
    const { name, value } = e.target;
    const updatedResult={...result,[name]: value };
    const actualResult=computeActualSGPA(updatedResult);
    actualResult.isModified = checkIfResultModified(actualResult);
    setResult(actualResult);
};
  const handleResultSave = async (e) => {
    e.preventDefault();
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await editresultapi.post('/updateResult',result,{headers:{'Authorization':`Bearer ${accessToken}`}});  
      if(response.data.result)
      {
        const computedResult ={...response.data.result,
          isModified: false }
        
        setInitialResult(computedResult); 
        setResult(computeActualSGPA(computedResult));
      }

         }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await editresultapi.post('/updateResult',result,{headers:{'Authorization':`Bearer ${nat}`}});   
                      if(response.data.result)
                        {
                          const computedResult ={...response.data.result,
                            isModified: false }
                          
                          setInitialResult(computedResult); 
                          setResult(computeActualSGPA(computedResult));
                        }
     
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };
  


const computeActualSGPA = (result) => {
    let allgp = Number(result['allgp']) || 0;
    let allcredit = Number(result['allcredit']) || 0;

    let majorcredit = Number(result['majorcredit']) || 0;
    let majorgp = Number(result['majorgp']) || 0;


    let actualMSGPA = majorcredit > 0 ? Math.round((majorgp / majorcredit) * 100) / 100 : 0;
    let actualASGPA = allcredit > 0 ? Math.round((allgp / allcredit) * 100) / 100 : 0;


    return {
      ...result,
      actualMSGPA,
      actualASGPA,
    };
};


  
const fetchSemesterResult=async ()=>{
    setDataLoaded(false);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await editresultapi.post('/getSemesterResultDetails',{rollno,session,semester},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      
       // Compute courses and add an isModified flag to each course
       const computedCourses = response.data.semesterResultDetails.courseList.map(course => ({
        ...course,
        isModified: false // Set initial isModified flag to false
    }));   
    setCourses(computeActualScores(computedCourses));
    setInitialCourses(computedCourses); // Save initial state of courses

    if(response.data.semesterResultDetails.result)
    {
      const computedResult ={...response.data.semesterResultDetails.result,
        isModified: false }
      
      setInitialResult(computedResult); 
      setResult(computeActualSGPA(computedResult));
      setDataLoaded(true);
    }else{
      setInitialResult({}); 
      setResult({});
      setDataLoaded(true);
    }
    
        //alert(JSON.stringify(response.data.marksData));
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await editresultapi.post('/getSemesterResultDetails',{rollno,session,semester},{headers:{'Authorization':`Bearer ${nat}`}});   
                        // Compute courses and add an isModified flag to each course
        const computedCourses = response.data.semesterResultDetails.courseList.map(course => ({
          ...course,
          isModified: false // Set initial isModified flag to false
      }));
      
      setCourses(computeActualScores(computedCourses));
      setInitialCourses(computedCourses); // Save initial state of courses
      
      if(response.data.semesterResultDetails.result)
        {
          const computedResult ={...response.data.semesterResultDetails.result,
            isModified: false }
          
          setInitialResult(computedResult); 
          setResult(computeActualSGPA(computedResult));
          setDataLoaded(true);
        }
        else{
          setInitialResult({}); 
          setResult({});
          setDataLoaded(true);
        }
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
              setDataLoaded(true);
            }
}
    // Function to check if a course has been modified
const checkIfCourseModified = (course, index) => {
  const initialCourse = initialCourses[index];
  const isModified = 
  course.course_type != initialCourse.course_type ||
  course.midterm != initialCourse.midterm ||
  course.practical != initialCourse.practical ||
  course.endterm != initialCourse.endterm ||
  course.percent != initialCourse.percent ||
  course.grade != initialCourse.grade ||
  course.gradepoint != initialCourse.gradepoint ||
  course.honur_point != initialCourse.honur_point||
  
  course.midterm_total != initialCourse.midterm_total ||
  course.practical_total != initialCourse.practical_total ||
  course.endterm_total != initialCourse.endterm_total ||
  course.midterm_pass != initialCourse.midterm_pass ||
  course.practical_pass != initialCourse.practical_pass ||
  course.endterm_pass != initialCourse.endterm_pass ||
  course.credit != initialCourse.credit;
  return isModified;
  //midterm_total,practical_total,endterm_total,midterm_pass, practical_pass,endterm_pass,credit
};
const checkIfResultModified = (result) => {
  const isModified = 
  result.majorcredit != initialResult.majorcredit ||
  result.allcredit != initialResult.allcredit ||
  result.majorgp != initialResult.majorgp ||
  result.allgp != initialResult.allgp ||
  result.sgpamajor != initialResult.sgpamajor||
  result.sgpaall != initialResult.sgpaall||
  result.result != initialResult.result||
  result.result_date != initialResult.result_date||
  result.issue_date != initialResult.issue_date||
  result.gradecard_slno != initialResult.gradecard_slno||
  result.exam_month != initialResult.exam_month||
  result.exam_year != initialResult.exam_year||
  result.exam_type != initialResult.exam_type||
  result.credit_earned != initialResult.credit_earned;
  return isModified;
};

useEffect(()=>{  
  fetchSemesterResult();
  },[]);
  
  useEffect(()=>{
   
     // Compute the total honour points
     const totalHonourPoints = courses.reduce((sum, course) => {
      return sum + (parseFloat(course.honur_point) || 0);
  }, 0);
     const totalCredits=courses.reduce((sum, course) => {
      return sum + (parseFloat(course.credit) || 0);
  }, 0);
  
  setTotalHonourPoints(totalHonourPoints); 
  setTotalCredit(totalCredits);  // Assuming you have a state for this

  const computeMajorTotals = () => {
    let totalMajorCredit = 0;
    let totalMajorHonourPoint = 0;
  
    courses.forEach(course => {
      if (course.course_type === "core") {
        totalMajorCredit += parseFloat(course.credit) || 0;
        totalMajorHonourPoint += parseFloat(course.honur_point) || 0;
      }
    });
  
    return { totalMajorCredit, totalMajorHonourPoint };
  };
  const {totalMajorCredit, totalMajorHonourPoint}=computeMajorTotals();
  setTotalMajorHonourPoint(totalMajorHonourPoint);
  setTotalMajorCredit(totalMajorCredit);
    },[courses]);
    
    const toggleShowDetails = () => {
      //alert('clicked');
      setShowDetails(prev => !prev);
    };

  return (
   <div className="w-full p-1  mx-auto text-gray-600 bg-blue-100 mb-2 ">
     <div className="w-full  flex justify-center items-center border-b-[1px] border-b-red-900 lg:gap-4 text-center">

          <div className=" flex p-2">
            <label className="text-gray-500 text-sm">Session:</label>
            <p className="text-gray-800 text-sm font-semibold">{session}</p>
          </div>
          <div className=" flex p-2">
            <label  className="text-gray-500 text-sm">Semester:</label>
            <p className="text-gray-800 text-sm font-semibold">{semester}</p>
          </div>
            <div className="flex p-2">
                      <button 
                        className="bg-blue-200 text-red font-semibold w-10 h-10 rounded-full flex items-center justify-center" 
                        onClick={toggleShowDetails}
                      >
                        {showDetails ? <AiOutlineUp size={20} /> : <AiOutlineDown size={20} />}
                      </button>          
            </div>
      </div>

      { dataLoaded &&  <div
  className={`w-full bg-yellow-100 transition-all duration-500 overflow-hidden ${
    showDetails ? "max-h-[2000px] opacity-100 scale-100" : "max-h-0 opacity-0 scale-100"
  }`}
>


          {courses.map((course, index) => (
            <CourseForm
              key={index}
              index={index}
              course={course}
              handleChange={handleCourseChange}
              handleCourseSave={handleCourseSave}
              handleCourseDelete={handleCourseDelete}
            />
          ))}

          {courses.length>0 && <ResultForm totalMajorHonourPoint={totalMajorHonourPoint} totalMajorCredit={totalMajorCredit} result={result} handleChange={handleResultChange}  handleResultSave={handleResultSave} totalHonourPoint={totalHonourPoint} totalCredit={totalCredit}/>
          }
          {courses.length<=0 && 
          <div>
            <p className="w-full text-center p-2 text-red-600">No formfillup courses!</p>
          </div>
          }
      </div>
     }
    </div>
  );
}
